import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from "@material-ui/core/styles";
import { 
	Box, 
	LinearProgress, 
	Skeleton, 
	Typography 
} from '@mui/material';
import { Button } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
	backdrop: {
	  zIndex: 1500	//Make backdrop show on top of everything
	}
  }));

  function LinearProgressWithLabel(props) {
	return (
	  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
		<Typography color={props.color} gutterBottom>
		  {props.text}
		</Typography>
		<Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
		  <Box sx={{ width: '100%', mr: 1 }}>
			<LinearProgress color={props.color} variant="determinate" {...props} />
		  </Box>
		  <Box sx={{ minWidth: 35 }}>
			<Typography variant="body2" color="text.secondary">{`${Math.round(
			  props.value,
			)}%`}</Typography>
		  </Box>
		</Box>
	  </Box>
	);
	}

	function CircularProgressWithLabel(props) {
		return (
			<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
				<Typography 
					color={props.color} 
					style={{
						marginBottom: '10px',
					}} 
					gutterBottom
				>
					{props.text}
				</Typography>
				<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<CircularProgress 
						size={24}
						color='primary'
					/>
				</Box>
			</Box>
		);
	}


const Loading = (props) => {
	const dispatch = useDispatch();
	const state = useSelector(state => state);
	const classes = useStyles();

	if (props.type === "circular") {
		return (
			<div style={{ position: 'relative', width: '100%', height: `${props.height ? props.height : 100}px` }}>
				<Skeleton variant="rect" width="100%" height="100%" animation="pulse"/>
				<div style={{ 
					position: 'absolute', 
					top: '50%', 
					left: '50%', 
					transform: 'translate(-50%, -50%)'
				}}>
					<CircularProgressWithLabel color="primary" text={props.text}/>
				</div>
				{props.button ?                 
				<Button 
                    variant="outlined" 
                    color="primary" 
                    style={{ 
                        position: 'absolute',
                        bottom: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)'
                    }}
                    onClick={props.onClick}
                >
                    {props.buttonText}
                </Button>
				: null}
			</div> 
		);
	}
	else if (props.type === "linear")
	{
		return (
			<div style={{ position: 'relative', width: '100%', height: `${props.height ? props.height : 100}px` }}>
				<Skeleton variant="rect" width="100%" height="100%" animation="pulse"/>
				<div style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '90%'
				}}>
				<LinearProgressWithLabel 
					value={props.value} 
					valueBuffer={props.value*1.5}
					variant="buffer" 
					color="primary"
					text={props.text}
				/>
				{props.button ?                 
				<Button 
                    variant="outlined" 
                    color="primary" 
                    style={{ 
                        position: 'absolute',
                        bottom: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)'
                    }}
                    onClick={props.onClick}
                >
                    {props.buttonText}
                </Button>
				: null}
				</div>
			</div> 
		)
	}
	else if (props.type === "backdrop")
	{
		return (
			<Backdrop
				className={classes.backdrop}
				open={props.open}
				onClick={(event) => {event.stopPropagation();}} //used to disable backdrop clicking which disables the entire loading screen
			>
				<CircularProgressWithLabel color={"#f2f2f2"} text={props.text}/>
			</Backdrop>
		);
	}
}

export default Loading;
